<template>
  <div :class="!disabled ? 'slider-custom' : 'slider-custom-disabled'">
    <vue-slider
        ref="ref"
        v-model="value"
        v-bind="options"
        @change="changeVal"
    ></vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "SliderCustom",
  components: {
    VueSlider,
  },
  props: {
    defaultValue: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1,
    },
    interval: {
      type: Number,
      default: 0.01,
    },
    changeValue: {
      type: Function,
      default: () => {},
    },
    name: {
      type: String,
      default: 'update',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: 50,
      options: {
        dotSize: 20,
        width: 'auto',
        height: 8,
        contained: false,
        direction: 'ltr',
        data: null,
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 100,
        interval: 0.1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: 'active',
        tooltipPlacement: 'top',
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    };
  },
  mounted() {
    if (this.defaultValue) {
      this.value = this.defaultValue;
    }
    this.options = {
      ...this.options,
      min: this.min,
      max: this.max,
      interval: this.interval,
      disabled: this.disabled
    }
  },
  computed: {

  },
  methods: {
    changeVal() {
      EventHub.$emit('changeValue', {
        name: this.name,
        value: this.value
      });
    }
  }
}
</script>

<style>

.slider-custom .vue-slider-process {
  background-color: #45AC34 !important;
}

.slider-custom .vue-slider-dot-handle {
  border: 4px solid #45AC34;
}

.slider-custom-disabled .vue-slider-dot-handle, .slider-custom-disabled .vue-slider-dot-handle-disabled {
  border: 4px solid #92A1B9 !important;
}

.slider-custom .vue-slider:hover .vue-slider-dot-handle:hover, .slider-custom .vue-slider:hover .vue-slider-dot-handle {
  border-color: #45AC34 !important;
  transform: scale(1.25);
  box-shadow: none;
}

.slider-custom .vue-slider:hover .vue-slider .vue-slider-dot-handle {
  border-color: #45AC34;
}

.slider-custom-disabled .vue-slider:hover .vue-slider-process, .slider-custom-disabled .vue-slider .vue-slider-process {
  background-color: #92A1B9 !important;
}

.slider-custom-disabled .vue-slider-rail, .slider-custom .vue-slider-rail  {
  z-index: 0;
}
</style>
